export enum ScoreInputKind {
  DETECTION = "detection",
  AGGREGATE = "aggregate",
  POLICY_CONSTRAINT = "policy_constraint",
}
